import { createGlobalStyle } from 'styled-components';
import { createCssVariables } from '../../shared/cjs/createCssVariables';
import { TombacTheme } from '../../shared/tombac/tombacTypes';

export const CssVariables = createGlobalStyle<{ theme: TombacTheme }>`
  :root {
    ${({ theme }) => createCssVariables(theme)}
  }
`;
